import { render, staticRenderFns } from "./shortcutSection.vue?vue&type=template&id=15a29dfe&"
import script from "./shortcutSection.vue?vue&type=script&lang=js&"
export * from "./shortcutSection.vue?vue&type=script&lang=js&"
import style0 from "./style.module.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports